<template>
  <div id="app-container">
    <SideMenu class="app-nav" />
    <div class="app-col">
      <Header class="app-header" />
      <main class="app-main">
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import SideMenu from "@/components/SideMenu";

export default {
  name: "Main",
  components: { Header, SideMenu },
};
</script>

<style lang="scss">
// The nav rail runs the full height of the window; the top bar and the
// workspace stack to the right of it.
#app-container {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.app-nav {
  flex-shrink: 0;
}

.app-col {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
}

.app-header {
  flex-shrink: 0;
}

.app-main {
  flex-grow: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--surface-sunk);
  padding: 14px 16px;
  box-sizing: border-box;
}
</style>
